function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { delegateEventListener } from "@oddcamp/js-utils/src/event";
import { uniq, intersection, camelCase, snakeCase } from "lodash";

var PdxDol = /*#__PURE__*/function () {
  function PdxDol() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        params = _ref.params,
        excludeSelector = _ref.excludeSelector,
        includeSelector = _ref.includeSelector;

    _classCallCheck(this, PdxDol);

    this.started = false;
    this.paused = true;
    this.excludeSelector = ".js--pdxdol-exclude";
    this.includeSelector = "";
    this.defaultParams = {};
    this.paramNames = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

    if (params) {
      this.defaultParams = params;
      this.paramNames = uniq([].concat(_toConsumableArray(this.paramNames), _toConsumableArray(Object.keys(params).map(function (k) {
        return snakeCase(k);
      }))));
    }

    if (excludeSelector) this.excludeSelector = excludeSelector;
    if (includeSelector) this.includeSelector = includeSelector;
  }

  _createClass(PdxDol, [{
    key: "start",
    value: function start() {
      if (typeof window === "undefined" || typeof document === "undefined") return;
      this.paused = false;

      if (!this.started) {
        this.started = true;

        this._setup();
      }
    }
  }, {
    key: "resume",
    value: function resume() {
      this.paused = false;
    }
  }, {
    key: "pause",
    value: function pause() {
      this.paused = true;
    }
  }, {
    key: "isPaused",
    value: function isPaused() {
      return this.paused;
    }
  }, {
    key: "_setup",
    value: function _setup() {
      var _this = this;

      var url = new URL(window.location.href);
      this.paramNames.forEach(function (key) {
        var value = url.searchParams.get(key);
        if (value) window.sessionStorage.setItem("pdxDol:".concat(key), value);
      });
      delegateEventListener("a", "click", function (e, triggerEl) {
        if (_this.paused) return;
        if (e.defaultPrevented) return;
        if (_this.excludeSelector && triggerEl.closest(_this.excludeSelector)) return; // eslint-disable-line prettier/prettier

        var url = new URL(triggerEl.href);
        if (url.hostname == window.location.hostname) return;
        if (intersection(Array.from(url.searchParams.keys()), _this.paramNames).length) return; // eslint-disable-line prettier/prettier

        e.preventDefault();
        var sessionTags = {};

        _this.paramNames.forEach(function (key) {
          var value = window.sessionStorage.getItem("pdxDol:".concat(key));
          if (value) sessionTags[camelCase(key)] = value;
        });

        var utm = _objectSpread(_objectSpread(_objectSpread({}, _this.defaultParams), sessionTags), triggerEl.dataset);

        _this.paramNames.forEach(function (key) {
          var value = utm[camelCase(key)];
          if (value) url.searchParams.append(key, value);
        });

        if (triggerEl.target == "_blank" || e.ctrlKey || e.metaKey) {
          window.open(url.toString(), "_blank");
        } else {
          window.location.href = url.toString();
        }
      });
    }
  }]);

  return PdxDol;
}();

export default PdxDol;